(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["junio-combos"] && !Shopify.designMode) return;
  try {
    
(function(){
  var now = new Date();
  document.querySelectorAll('.acu-junio__card[data-unlock]').forEach(function(card){
    var unlockStr = card.getAttribute('data-unlock');
    if (!unlockStr) return;
    var unlockDate = new Date(unlockStr + 'T00:00:00');
    if (now >= unlockDate) card.classList.add('is-active');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipos-mama"] && !Shopify.designMode) return;
  try {
    
(function(){
  var carousels = document.querySelectorAll('[data-acu-carousel]');
  carousels.forEach(function(c){
    var track = c.querySelector('[data-acu-track]');
    var dots = c.querySelectorAll('[data-acu-dots] button');
    var prev = c.querySelector('.acu-tipos-mama__arrow--prev');
    var next = c.querySelector('.acu-tipos-mama__arrow--next');
    var count = dots.length;
    if (!track || count === 0) return;
    var i = 0;
    var timer = null;
    var INTERVAL = 3500;
    function go(idx){
      var w = track.clientWidth;
      if (!w) return;
      i = (idx + count) % count;
      track.scrollTo({ left: w * i, behavior: 'smooth' });
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === i); });
    }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    function start(){ stop(); timer = setInterval(function(){ go(i + 1); }, INTERVAL); }
    function restart(){ stop(); start(); }
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.dataset.i); restart(); }); });
    if (prev) prev.addEventListener('click', function(){ go(i - 1); restart(); });
    if (next) next.addEventListener('click', function(){ go(i + 1); restart(); });
    track.addEventListener('scroll', function(){
      var w = track.clientWidth; if (!w) return;
      var ni = Math.round(track.scrollLeft / w);
      if (ni !== i) { i = ni; dots.forEach(function(d, di){ d.classList.toggle('is-active', di === i); }); }
    }, { passive: true });
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'visible') start(); else stop();
    });
    // Arrancar con un pequeño delay para asegurar que track.clientWidth ya está calculado
    setTimeout(start, 200);
  });

  // Lazy-load de slides 2 y 3: cargar después del page load (no bloquean LCP)
  function loadDeferred(){
    document.querySelectorAll('[data-acu-defer-img]').forEach(function(pic){
      pic.querySelectorAll('source[data-srcset]').forEach(function(s){
        if (!s.srcset) { s.srcset = s.dataset.srcset; s.removeAttribute('data-srcset'); }
      });
      var img = pic.querySelector('img[data-src]');
      if (img && img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
    });
  }
  if (document.readyState === 'complete') setTimeout(loadDeferred, 1500);
  else window.addEventListener('load', function(){ setTimeout(loadDeferred, 1500); });
})();

  } catch(e) { console.error(e); }
})();
})();
